import { camelCase } from 'lodash-es';

const styles = (theme) => ({
  root: {
    height: '100%',
    minWidth: '320px',
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
      minWidth: '275px',
    },
  },
  menuItemIcon: {
    marginRight: theme.spacing.unit * 1.875,
    '& svg': {
      width: 30,
      height: 30,
      color: theme.palette.primary.dark,
    },
  },
  menuItem: {
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 1.1875}px ${
      theme.spacing.unit * 2
    }px ${theme.spacing.unit * 2.75}px`,
    '&:focus': {
      backgroundColor: '#f3f3f3',
    },
    '&:hover': {
      backgroundColor: '#f3f3f3',
    },
    borderColor: theme.palette.border.light,
    borderWidth: '0 1px 1px 1px',
    borderStyle: 'solid',
    '&:first-child': {
      borderTopWidth: '1px',
    },
    minHeight: '60px',
    '&:first-of-type': {
      '-webkit-box-shadow': 'inset 0 20px 15px -20px rgba(0, 0, 0, 0.15)',
      '-moz-box-shadow': 'inset 0 20px 15px -20px rgba(0, 0, 0, 0.15)',
      'box-shadow': 'inset 0 20px 15px -20px rgba(0, 0, 0, 0.15)',
      [theme.breakpoints.up('md')]: {
        '-webkit-box-shadow': 'none',
        '-moz-box-shadow': 'none',
        'box-shadow': 'none',
      },
    },
  },
  menuItemActive: {
    borderLeftWidth: '4px',
    paddingLeft: theme.spacing.unit * 2.25,
    borderLeftColor: theme.palette.primary.main,
  },
  menuItemText: {
    padding: `0 0 0 ${theme.spacing.unit}px`,
  },
  menuItemTextPrimary: {
    color: theme.palette.text.dark,
  },
  menuItemTextSecondary: {
    color: theme.palette.text.dark,
    fontSize: '1.1875rem',
  },
  name: {
    fontSize: '1.5rem',
    fontWeight: 600,
    padding: `${theme.spacing.unit * 2.05}px ${theme.spacing.unit * 4.375}px
    ${theme.spacing.unit * 2}px 0`,
  },
  logoContainer: {
    marginLeft: `-${theme.spacing.unit * 1.5}px`,
    width: '100%',
    '& :hover': {
      opacity: 0.8,
    },
  },
  logo: {
    margin: `0`,
    width: '90%',
  },
  shielded: {
    marginRight: theme.spacing.unit * 2,
    '& :hover': {
      opacity: 0.8,
    },
  },
  logoMenuItem: {
    paddingTop: theme.spacing.unit,
  },
});

export default styles;
